<div
  class="miq-home page-wrapper"
  [ngClass]="{
  'skip-mig-global-styles': $isEmbedded(),
  'mig-global-styles': !$isEmbedded(),
}"
>
  <miq-loading-indicator *miqLoadingIndicatorModeChange></miq-loading-indicator>

  <div class="page-sidebar">
    <mat-nav-list *ngIf="!isRequestPage" class="home-navigation-bar">
      <ng-container *ngFor="let item of menuItems">
        <ng-container *ngIf="!!item.permissions else publicItem">
          <mat-list-item
            *ngxPermissionsOnly="item.permissions"
            [ngClass]="{'active': item.active}"
            [routerLink]="item.routerLink"
            routerLinkActive="active"
            [matTooltip]="item.name | xTranslate"
            matTooltipClass="leftnav-tooltip"
            matTooltipPosition="right"
            class="home-navigation-bar__item"
          >
            <a>
              <mat-icon [svgIcon]="item.icon"> </mat-icon>
            </a>
          </mat-list-item>
        </ng-container>

        <ng-template #publicItem>
          <mat-list-item
            [ngClass]="{'active': item.active}"
            [routerLink]="item.routerLink"
            routerLinkActive="active"
            [matTooltip]="item.name | xTranslate"
            matTooltipClass="leftnav-tooltip"
            matTooltipPosition="right"
            home-navigation-bar__item
            class="home-navigation-bar__item"
          >
            <a>
              <mat-icon [svgIcon]="item.icon"></mat-icon>
            </a>
          </mat-list-item>
        </ng-template>
      </ng-container>
      <div class="env-container" *ngIf="env !== ''">
        <div class="env-label">{{ env | uppercase }}</div>
      </div>
      <mat-list-item
        (click)="!disableFlag && getHelp()"
        [matTooltip]="'core.feedback' | xTranslate"
        matTooltipClass="leftnav-tooltip"
        matTooltipPosition="right"
        class="home-navigation-bar__item home-navigation-bar__item--feedback"
      >
        <a>
          <mat-icon svgIcon="feedback-icon"></mat-icon>
        </a>
      </mat-list-item>
    </mat-nav-list>
  </div>
  <div class="page-content">
    <miq-navbar [appName]="appName" [userName]="userName" [clipboardLength]="clipboardLength"> </miq-navbar>
    <router-outlet></router-outlet>
    <miq-footer *ngIf="!$isClipboard()"></miq-footer>
  </div>
</div>
